module.exports = __webpack_public_path__ + "static/media/info.77ff930f.svg";